var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgOutage = function SvgOutage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9336 8.49609L12.6523 11.7773L15.9062 15.0312C16.1797 15.2773 16.1797 15.6875 15.9062 15.9336C15.6602 16.207 15.25 16.207 15.0039 15.9336L11.7227 12.6797L8.46875 15.9336C8.22266 16.207 7.8125 16.207 7.56641 15.9336C7.29297 15.6875 7.29297 15.2773 7.56641 15.0039L10.8203 11.75L7.56641 8.49609C7.29297 8.25 7.29297 7.83984 7.56641 7.56641C7.8125 7.32031 8.22266 7.32031 8.49609 7.56641L11.75 10.8477L15.0039 7.59375C15.25 7.32031 15.6602 7.32031 15.9336 7.59375C16.1797 7.83984 16.1797 8.25 15.9336 8.49609Z",
    fill: "white"
  })));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOutage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/outage.0d5570cb.svg";
export { ForwardRef as ReactComponent };